import { render, staticRenderFns } from "./TrailerRentalBox.vue?vue&type=template&id=68c945c4&"
import script from "./TrailerRentalBox.vue?vue&type=script&lang=js&"
export * from "./TrailerRentalBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports